<template>
  <div class="nx-signing-modal-method-p12">
    <h4>Please prepare your token for signing</h4>

    <h5 class="mt-4" v-if="loading">
      The client program is going to ask for your certificate
    </h5>
    <h5 class="mt-4" v-else>Please select one of the following certificate</h5>

    <div class="mt-4">
      <b-spinner v-if="loading" />
      <b-list-group v-else>
        <b-list-group-item
          v-for="cert of certs"
          :key="cert.alias"
          class="text-nowrap"
          button
          @click="sign(cert)"
        >
          <span>{{ cert.subjectDn }}</span> / <span>{{ cert.alias }}</span> /
          <span>{{ cert.expiredDate }}</span>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>

import SignClient from "@nextore/nx-signing/src/api/sign-client.api";
export default {
  props: {
    value: {},
    isNonPdf: {
      type: Boolean,
      default: false
    },
    isDrawing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      certs: [],
      loading: true,
      signClient: null,
    };
  },
  async created() {
    this.signClient = new SignClient();

    try {
      const signClient = this.signClient;

      await signClient.init();

      const certs = await signClient.getUsbCerts();

      this.certs = certs.certs;

      this.loading = false;
    } catch (ex) {
      if (ex.response) {
        this.$emit("input", ex.response.data);
      } else if (ex.message === "CLIENT_NOT_EXIST") {
        this.$emit("input", ex.message);
      }

      this.$emit("fail");

      throw ex;
    }
  },
  methods: {
    async sign(cert) {
      const signClient = this.signClient;

      try {
        this.loading = true;
        const { digest } = this.value;

        var dataFinal ={};
        if (!this.isDrawing) {
          const data = await signClient.usbSignDoc(cert.alias, digest.digest);
          dataFinal = data;
        } else {
          const data = await signClient.usbSignPdf(cert.alias, digest.digest);
          dataFinal = data;
        }

        this.$emit("input", {
          ...this.value,
          signature: dataFinal,
        });
        this.$emit("next");

        this.loading = false;
      } catch (ex) {
        this.$emit("input", ex.response.data);
        this.$emit("fail");

        throw ex;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
</style>
